module.exports = __webpack_public_path__ + "media/thumbnail.e2ce7fac.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/bouncy/assets/thumbnail.jpeg
// module id = ./src/templates/bouncy/assets/thumbnail.jpeg
// module chunks = 0